import { render, staticRenderFns } from "./notifications-settings.vue?vue&type=template&id=3f08c3ce&"
import script from "./notifications-settings.vue?vue&type=script&lang=js&"
export * from "./notifications-settings.vue?vue&type=script&lang=js&"
import style0 from "./notifications-settings.vue?vue&type=style&index=0&id=3f08c3ce&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports